module.exports = __webpack_public_path__ + "img/lexoffice-icon.ad03a6f0.png";